import * as React from "react";
type Props = {
  className?: string,
};
function SvgGutFriendly({ className }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-GutFriendly"
      className={className}
    >
      <path
        d="M23.9856 28.8C21.1113 28.8 18.7494 26.6458 18.4119 23.8623C18.386 23.6417 18.373 23.4145 18.373 23.1874C18.373 20.4947 20.2742 18.2431 22.8177 17.7047C23.1941 17.6268 23.5834 17.5813 23.9856 17.5813C27.0807 17.5813 29.5918 20.0924 29.5918 23.1874C29.5918 26.2889 27.0807 28.8 23.9856 28.8Z"
        stroke="currentColor"
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8309 24.3424L21.3449 22.8954L21.1309 22.6878L20.2094 23.5508L20.0537 23.6935L22.8763 26.5485L27.9115 21.5978L26.7629 20.4233L22.8309 24.3424Z"
        stroke="currentColor"
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.557 2.59922V2.48242C16.557 3.35189 17.2642 4.05265 18.1272 4.05265H22.0333C23.2596 4.05265 24.395 4.49391 25.2775 5.2401C26.16 5.9862 26.7829 7.03092 26.9841 8.24424C27.036 8.51676 27.0554 8.79583 27.0554 9.06834C27.0554 9.34731 27.036 9.62628 26.9841 9.89879C26.5817 12.3191 24.486 14.0905 22.0333 14.0905H7.72596C7.68061 14.0905 7.6416 14.1294 7.6416 14.1748C7.6416 14.2203 7.68061 14.2526 7.72596 14.2526H18.0168C19.8791 14.2526 21.5855 15.2843 22.455 16.926L22.5783 17.166C22.6691 17.3412 22.7535 17.5229 22.8184 17.7045"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M14.3564 27.5737V24.8031C14.3564 24.284 14.7717 23.8623 15.2973 23.8623H18.4117"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4678 2.59938V2.40002C11.4678 6.04713 14.4244 9.00367 18.0714 9.00367H21.6611H7.54514C4.95848 9.00367 2.77332 10.93 2.44231 13.4954C2.38872 13.9107 2.38647 14.3318 2.43579 14.7475C2.73971 17.3096 4.9119 19.2393 7.49191 19.2393H17.8686C17.876 19.2393 17.883 19.2423 17.8881 19.2474C17.9049 19.2646 17.8928 19.2936 17.8687 19.2936H14.1795C11.4821 19.2936 9.29531 21.4803 9.29531 24.1778V27.6685"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9856 17.5813C23.5834 17.5813 23.1941 17.6268 22.8177 17.7047C20.2742 18.2431 18.373 20.4947 18.373 23.1874C18.373 23.4145 18.386 23.6417 18.4119 23.8623C18.7494 26.6458 21.1113 28.8 23.9856 28.8C27.0807 28.8 29.5918 26.2889 29.5918 23.1874C29.5918 20.0924 27.0807 17.5813 23.9856 17.5813ZM22.8761 26.5486L20.0536 23.6936L20.2093 23.5508L21.1307 22.6879L21.3448 22.8955L22.8307 24.3424L26.7628 20.4234L27.9112 21.5978L22.8761 26.5486Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9115 21.5978L22.8763 26.5485L20.0537 23.6935L20.2094 23.5508L21.1309 22.6878L21.3449 22.8954L22.8309 24.3424L26.7629 20.4233L27.9115 21.5978Z"
        stroke="currentColor"
        strokeWidth={0.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9115 21.5978L22.8763 26.5485L20.0537 23.6935L20.2094 23.5508L21.1309 22.6878L21.3449 22.8954L22.8309 24.3424L26.7629 20.4233L27.9115 21.5978Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgGutFriendly;
